class TabFeatureCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.tabs = Array.from(this.querySelectorAll('[data-tab-index]'));
    this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
    this.captions = Array.from(this.querySelectorAll('[data-caption-index]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (this.slides.length < 1) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.goTo(Number(tab.dataset.tabIndex));
      });
    });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(Number(dot.dataset.dotIndex));
      });
    });

    this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.initTouch();
    this.goTo(0, false);
  }

  getSlideCount() {
    return this.slides.length;
  }

  normalizeIndex(index) {
    const count = this.getSlideCount();
    if (count < 1) return 0;
    return ((index % count) + count) % count;
  }

  goTo(index, animate = true) {
    const nextIndex = this.normalizeIndex(index);
    this.currentIndex = nextIndex;

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === nextIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.captions.forEach((caption, captionIndex) => {
      caption.classList.toggle('is-active', captionIndex === nextIndex);
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === nextIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (!animate) return;
  }

  initTouch() {
    const slidesContainer = this.querySelector('.tab-feature-carousel__slides');
    if (!slidesContainer || this.getSlideCount() < 2) return;

    let touchStartX = 0;
    let touchEndX = 0;

    slidesContainer.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    slidesContainer.addEventListener(
      'touchend',
      (event) => {
        touchEndX = event.changedTouches[0].screenX;
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) < 40) return;
        if (delta < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      },
      { passive: true }
    );
  }
}

customElements.define('tab-feature-carousel-component', TabFeatureCarouselComponent);
